import PromotionsService from './PromotionsService';
export default PromotionsService;
